import React from 'react'
import { styled } from 'styletron-react'
import { hexToRgba } from '@/scenes/engine/utils/utils'
import { lightTheme } from '@/customTheme'
import { nonBackground } from '../FloatingIcons/NonBackground'

const CircleContainer = styled('div', () => ({
  width: '24px',
  height: '24px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}))

export const CircleImg = styled('div', (props: { $src: string }) => ({
  backgroundImage: `url('${props.$src}')`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  width: '22px',
  height: '22px',
  borderRadius: '50%',
  objectFit: 'cover',
  display: 'block',
  boxShadow: `inset 0 0 0 1px ${hexToRgba(lightTheme.colors.black, 0.1)}`
}))

export const WrapCicleColor = styled('div', (props: { $backgroundColor?: string }) => ({
  width: '22px',
  height: '22px',
  borderRadius: '50%',
  display: 'block',
  boxShadow: `inset 0 0 0 1px ${hexToRgba(lightTheme.colors.black, 0.1)}`,
  backgroundColor: props.$backgroundColor
}))

export interface CircleImageRendererProps {
  src?: string
  backgroundColor?: string
}

const FloatingInspectorCircleRenderer: React.FC<CircleImageRendererProps> = ({ src, backgroundColor }) => {
  const isTransparent = src === 'transparent' || backgroundColor === 'transparent'
  const isBackgroundColor = backgroundColor && backgroundColor !== 'transparent'
  const isSrcBackgroundColor = !backgroundColor && typeof src === 'string' && src.trim().startsWith('#')

  let content: React.ReactNode

  if (isTransparent) {
    content = <CircleImg $src={nonBackground()} />
  } else if (isBackgroundColor) {
    content = <WrapCicleColor $backgroundColor={backgroundColor} />
  } else if (isSrcBackgroundColor) {
    content = <WrapCicleColor $backgroundColor={src} />
  } else {
    content = <CircleImg $src={src} />
  }

  return <CircleContainer>{content}</CircleContainer>
}

export default FloatingInspectorCircleRenderer
